import isStaging from './isStaging'
import isDevelopment from './isDevelopment'

// eslint-disable-next-line import/no-mutable-exports
let hostname = 'https://api.infowijs.nl'

if (isStaging) {
  hostname = 'https://api.staging.infowijs.nl'
}

if (isDevelopment) {
  hostname = process.env.INFOWIJS_HOSTNAME_API || 'https://api.infowijs.test'
}

export default hostname
